export enum NotificationChannelEnum {
    Mail = 1,
}
